import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["earningInput", "averageOutput"]

  connect() {
    this.calculate()
  }

  calculate() {
    const values = this.earningInputTargets
      .map(input => parseFloat(input.value) || 0)
      .filter(val => val > 0)

    // Solo recalcular si hay exactamente 4 valores. Si no, NO tocar el output:
    // conservamos el promedio persistido que renderizó el servidor en lugar de
    // machacarlo con 0.00 en cada connect().
    if (values.length !== 4) {
      return
    }

    const average = values.reduce((sum, val) => sum + val, 0) / 4
    this.updateAverage(average)
  }

  updateAverage(average) {
    if (this.hasAverageOutputTarget) {
      const formatted = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2
      }).format(average)

      this.averageOutputTarget.value = formatted
    }
  }
}
